import { createSlice } from "@reduxjs/toolkit";

export const initialSsrState = () => ({
    // true is server render, or should match server render
    // eg. components that are dependent on session storage
    // would elide those in order to prevent hydration mismatches
    server: true,
});

const ssrSlice = createSlice({
    name: "ssr",
    initialState: initialSsrState(),
    reducers: {
        hydrate: () => {
            return {
                server: false,
            };
        },
    },
});

export const { hydrate } = ssrSlice.actions;

export default ssrSlice.reducer;
